import styled, { css } from 'styled-components';
import { Box, Avatar } from '@cleartax/zoids';
import { CANCEL_SEARCH, SEARCH } from '../../constants/urls';

export const TableRow = styled.div`
  & > button {
    height:62px;
    width:100%;
    box-sizing:border-box;
    padding-left:4%;
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    border-bottom:1px solid #E8E8E8;
  }
`;

export const BranchRow = styled.div`
  button {
    height:48px;
    width:100%;
    box-sizing:border-box;
    padding-left:25.5%;
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
  }
`;

export const GSTRow = styled.div`
  & > button {
    height:62px;
    width:100%;
    box-sizing:border-box;
    padding-left:15%;
    display:flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
  }
`;

export const GSTName = styled.div`
  width:100%;
  font-family: Nunito;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 120%;
  color:black;
  display:flex;
  flex-direction:row;
`;

export const GSTColumn = styled.div`
display:flex;
flex-direction:column;
margin-left:16px;
width:80%;
`;

export const DrawerItem = styled.button<{ 
  disabled?: boolean,
selected:boolean}>`
  display: block;
  width: 100%;
  text-align: left;
  background-color: transparent;
  border: 0;
  outline:none;

  ${props =>
    props.selected &&
    css`
    background-color:#EEEFFF;
    `
  }
  cursor: pointer;

  ${props =>
    props.disabled &&
    css`
      opacity: 0.7;
      pointer-events: none;
    `}
`;

export const GSTDrawItems = styled.div`
width:87%;
display:flex;
flex-direction:row;
justify-content:flex-start;
align-items:center;
`;

export const SearchBox = styled(Box)`
  position:relative;
  margin: 20px 0px 20px 0px;
  height:37px;
  width:92%;
  margin-left:4%;
`;

export const SearchField = styled.input`
width:100%;
height:100%;
overflow:hidden;
white-space: nowrap;
text-overflow: ellipsis;
border: 1px solid #E1E5EE;
border-radius:8px;
font-family: Nunito;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 19px;
placeholderTextColor: #828999;
color:#303645;
outline:none;
background: url(${SEARCH}) no-repeat 0px 2px;
background-size: 32px 32px;
text-indent: 33px;

&:focus{
  border-color: #E5E6FF;
  border-width:2px;
}
`;

export const CancelButton = styled.button`
position:absolute;
outline:none;
margin-top:3px;
margin-left:-37px;
border:none;
outline:none;
background-color:#FFFF;
width:32px;
height:31px;
background: url(${CANCEL_SEARCH}) no-repeat 0px 0px;
background-size: 32px 32px;
`;

export const StyledAvatar: any = styled(Avatar)`
  display: inline-block;
  background: '#92959A';
  color: '#FFFFFF';
`;

export const GSTINNumber = styled.span`
font-family: Nunito;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 140%;
color: #6D6D6D;

`;

export const BranchText = styled(GSTName)`
  width:85%;
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const BlueImg = styled.img`
position:static;
margin-right:3%;
width:38px;
height:38px;
`;